import React, { useState, useEffect } from "react";
import { Row, Col, Select, Form, Input, Checkbox } from "antd";
import { connect } from "react-redux";

import QADynamicTable from "../../../../components/qa_custom/DynamicTable";
import { selectDataFromExecQuery } from "../../actions/funcional.group";
import { getColumnSearchProps } from "../search.into.table.columns";

const { Option } = Select;
const EXEC_QUERY_NAME = {
    requisitos_nec_grupos_func: "requisitos_nec_grupos_func",
    tipos_requisitos: "tipos_requisitos",
    requisitos: "requisitos",
    todos_requisitos: "todos_requisitos",
};

const Requirement = ({
    form,
    selectDataFromExecQuery, //from redux action
    soma_ponderacao_requisitos,
    selectedGrupoExist,
    idGrupoExist,
    set_requisito_necessario,
    requisito_necessario,
    setRequirementPonderationCalculeValue,
}) => {
    const { getFieldDecorator } = form;

    const [dataSource, setDataSource] = useState([]);
    const [requirementTypes, setRequirementTypes] = useState([]);
    const [requirements, setRequirements] = useState([]);
    const [requirementTipeId, setRequirementTypeId] = useState(undefined);
    const [sumPonderation, setSumPonderation] = useState(false);
    // const [ponderationCalculeValue, setPonderationCalculeValue] = useState(undefined);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (requisito_necessario.length) {
            setDataSource(requisito_necessario);
            setSumPonderation(!sumPonderation);
        }
    }, []);

    /**
     * do ponderation calcule
     */
    useEffect(() => {
        const sum = dataSource
            .filter((item) => item["ativo"] === "t")
            .map((item) => Number(item.ponderacao))
            .reduce((a, b) => a + b, 0);
        setRequirementPonderationCalculeValue(sum);
    }, [sumPonderation]);

    /**
     * fetch "requisitos" from group exist
     */
    useEffect(
        () => {
            // if (selectedGrupoExist || idGrupoExist) {
            (async () => {
                setLoading(true);
                // const response = await selectDataFromExecQuery({
                //     query: EXEC_QUERY_NAME.requisitos_nec_grupos_func,
                //     id_ficha_funcao: idGrupoExist || 0,
                //     sel_grupo_exist: selectedGrupoExist,
                // });
                // if (response.result) {
                //     if (Array.isArray(response.result)) {
                //         const data = [];
                //         response.result.forEach((item, index) => {
                //             data.push({ __key__: index, ...item });
                //         });
                //         await setDataSource(data);
                //         set_requisito_necessario(data);
                //         setSumPonderation(!sumPonderation); // forcing calculate ponderation
                //     }
                // }

                // setSumPonderation(!sumPonderation);

                /**
                 * get all reqisitos
                 */
                const req = await selectDataFromExecQuery({
                    query: EXEC_QUERY_NAME.todos_requisitos,
                });
                if (req.result) {
                    if (Array.isArray(req.result)) {
                        setRequirements(req.result);
                    }
                }
                setLoading(false);
            })();
            // }
        },
        [
            /*selectedGrupoExist, idGrupoExist*/
        ]
    );

    /**
     * fetch "tipos requisitos"
     */
    useEffect(() => {
        (async () => {
            const response = await selectDataFromExecQuery({
                query: EXEC_QUERY_NAME.tipos_requisitos,
            });
            if (response.result) {
                if (Array.isArray(response.result)) {
                    setRequirementTypes(response.result);
                }
            }
        })();
    }, []);

    /**
     * fetch "requisitos"
     */
    // useEffect(() => {
    //     if (requirementTipeId) {
    //         (async () => {
    //             const response = await selectDataFromExecQuery({
    //                 query: EXEC_QUERY_NAME.requisitos,
    //                 tipo_requisito: requirementTipeId,
    //             });
    //             if (response.result) {
    //                 if (Array.isArray(response.result)) {
    //                     setRequirements(response.result);
    //                 }
    //             }
    //         })();
    //     }
    // }, [requirementTipeId]);

    /**
     * add row to table
     */
    const addRowToTable = () => {
        let size = dataSource.length > 0 ? Math.max(...dataSource.map((item) => Number(item.__key__))) + 1 : 0;
        setDataSource([{ __key__: size }, ...dataSource]);
    };

    /**
     * remove row from table
     */
    const removeRowFromTable = (selectedRowKeys) => {
        const newDataSource = [];
        dataSource.forEach((item) => {
            if (!selectedRowKeys.includes(item.__key__)) newDataSource.push(item);
        });
        setDataSource(newDataSource);
        setSumPonderation(!sumPonderation);
    };

    /**
     * handle change when user enter degit
     */
    const onChange = async (dataIndex, value, record) => {
        const newState = [...dataSource];

        record[dataIndex] = value;
        const index = newState.findIndex((item) => item.__key__ === record.__key__);
        newState.splice(index, 1, record);
        // newState[index] = record;

        await setDataSource([...newState]);
        set_requisito_necessario([...newState]);
        if (dataIndex === "ponderacao" || dataIndex === "ativo") {
            setSumPonderation(!sumPonderation);
        }
    };

    /**
     * columns to table
     */
    const columns = [
        {
            title: "Tipo de requisitos",
            dataIndex: "tipo_requisito",
            width: "35%",
            ...getColumnSearchProps("tipo_requisito"),
            onFilter: (value, record) => {
                const filteredValue = requirementTypes
                    .filter((item) => item.designacao.toString().toLowerCase().includes(value.toLowerCase()))
                    .map((item) => item.tipo_requisito);
                return filteredValue.includes(record["tipo_requisito"]);
            },
            render: (text, record) => {
                const defaultValue = typeof text !== "object" && text ? text : undefined;

                return (
                    <Select
                        showSearch
                        allowClear
                        dropdownMatchSelectWidth={false}
                        style={{ maxWidth: "300px", margin: "0 auto", padding: "0" }}
                        placeholder="Selecione uma opção"
                        optionFilterProp="children"
                        value={requirementTypes
                            .map((element) => element.tipo_requisito)
                            .find((item) => item === defaultValue)}
                        onChange={(value) => {
                            onChange("tipo_requisito", value, record);
                            setRequirementTypeId(value);
                        }}
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {requirementTypes.map((item) => (
                            <Option key={item.tipo_requisito} value={item.tipo_requisito}>
                                {item.designacao}
                            </Option>
                        ))}
                    </Select>
                );
            },
        },
        {
            title: "Descrição",
            dataIndex: "requisito",
            width: "35%",
            ...getColumnSearchProps("requisito"),
            onFilter: (value, record) => {
                const filteredValue = requirements
                    .filter((item) => item.designacao.toString().toLowerCase().includes(value.toLowerCase()))
                    .map((item) => item.requisito);
                return filteredValue.includes(record["requisito"]);
            },
            render: (text, record) => {
                const defaultValue = typeof text !== "object" && text ? text : undefined;

                return (
                    <Select
                        showSearch
                        allowClear
                        dropdownMatchSelectWidth={false}
                        style={{ maxWidth: "300px", margin: "0 auto", padding: "0" }}
                        placeholder="Selecione uma opção"
                        optionFilterProp="children"
                        value={requirements.map((element) => element.requisito).find((item) => item === defaultValue)}
                        onChange={(value) => onChange("requisito", value, record)}
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {requirements
                            .filter((item) => item.tipo_requisito === record.tipo_requisito)
                            .map((item) => {
                                return (
                                    <Option key={item.requisito} value={item.requisito}>
                                        {item.designacao}
                                    </Option>
                                );
                            })}
                    </Select>
                );
            },
        },
        {
            title: "Ponderação",
            dataIndex: "ponderacao",
            width: "20%",
            ...getColumnSearchProps("ponderacao"),
            render: (text, record) => (
                <Form.Item style={{ width: "100%", margin: "0 auto", padding: "0" }}>
                    <Input
                        onChange={(e) => onChange("ponderacao", e.target.value, record)}
                        type="number"
                        defaultValue={typeof text !== "object" ? text : undefined}
                        style={{ width: "100%" }}
                        placeholder="Introduza a ponderação"
                    />
                </Form.Item>
            ),
        },
        {
            title: "Ativo?",
            dataIndex: "ativo",
            width: "10%",
            align: "center",
            ...getColumnSearchProps("ativo"),
            render: (text, record) => (
                <Checkbox
                    onChange={(e) => onChange("ativo", e.target.checked === true ? "t" : "f", record)}
                    defaultChecked={text === "t" || text === true}
                />
            ),
        },
    ];

    return (
        <>
            {/* <Row>
                <Col xs={24} sm={6}>
                    <Form.Item label="Ponderação na dimensão">
                        {getFieldDecorator("soma_ponderacao_requisitos", {
                            initialValue: ponderationCalculeValue,
                        })(
                            <Input
                                readOnly
                                type="number"
                                size="small"
                                style={{ width: "100%" }}
                                placeholder="Ponderação na dimensão"
                            />
                        )}
                    </Form.Item>
                </Col>
            </Row> */}
            <QADynamicTable
                data={dataSource}
                columns={columns}
                addRowToTable={addRowToTable}
                onRemoveItem={removeRowFromTable}
                loadingData={loading}
            />
        </>
    );
};

const mapDispatchToProps = {
    selectDataFromExecQuery,
};

export default connect(null, mapDispatchToProps)(Requirement);
